<template>
  <section id="all-report-downloads">
    <div class="container-sm">
      <CaseReports></CaseReports>
      <SendoutReport v-if="hasPermission('exports', 'sendout')"></SendoutReport>
      <HospitalsReport></HospitalsReport>
      <PhysiciansReport></PhysiciansReport>
      <ExceptionReport v-if="!isBillingUser"></ExceptionReport>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const CaseReports = defineAsyncComponent(() =>
  import("@/components/reports/CaseReports")
);
const SendoutReport = defineAsyncComponent(() =>
  import("@/components/reports/SendoutReport")
);
const HospitalsReport = defineAsyncComponent(() =>
  import("@/components/reports/HospitalsReport")
);
const PhysiciansReport = defineAsyncComponent(() =>
  import("@/components/reports/PhysiciansReport")
);
const ExceptionReport = defineAsyncComponent(() =>
  import("@/components/reports/ExceptionReport")
);
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

export default {
  mixins: [UserPermissionsHelper],

  components: {
    CaseReports,
    SendoutReport,
    HospitalsReport,
    PhysiciansReport,
    ExceptionReport,
  },
  async mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  async unmounted() {
    // Remove Class to body on scroll
    document.body.classList.remove("fixedNavbarOnComponent");
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    async onScroll() {
      // Get the scroll position, you can adjust this value based on your requirement
      const scrollPosition = window.scrollY;
      // Add a class to the body element based on the scroll position
      // For example, adding a class 'scrolled' when the user scrolls more than 100px
      if (scrollPosition > 1) {
        document.body.classList.add("fixedNavbarOnComponent");
      } else {
        document.body.classList.remove("fixedNavbarOnComponent");
      }
    },
  },
};
</script>

<style lang="scss">
@import "/src/assets/scss/mixins/app.scss";

#all-report-downloads {
  padding-bottom: 2rem;
  @include checkbox-styles;

  .export {
    margin-top: 15px;
    background: #fff;

    &__header {
      min-height: 30px;
      border-bottom: 1.2px solid #e7e7f7;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        display: inline-flex;
        align-items: center;
        width: 230px;
        max-width: 215px;
        color: #1b2459;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 0;
        border-radius: 0 !important;
        padding: 7px 15px 5px 15px;
        border-right: 1.2px solid #e7e7f7;
      }
    }
    &__body {
      background: #ffffff;
      border-radius: 6.40017px;
      .sub-header {
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 15px;
        border-bottom: 1.28003px solid #e7e7f7;

        .download-btn {
          min-height: 30px;
          max-height: 30px;
          padding: 5px 10px;
          font-size: 13px;
          background: #273480;
          color: #fff;
          font-weight: 500;
          border: none;
          border-radius: 6.4px;
          text-transform: uppercase;
          transition: all 0.2s ease-in-out;
        }
      .button-wrapper { 
        display: flex;
        gap: 8px; 
        }
      }
      .date-type-checkbox {
        display: flex;
        align-items: center;
        .checkbox-header {
          color: #0a5da6;
          font-weight: 600;
          font-size: 14px;
        }
        .radio-block {
          display: flex;
          align-items: center;
          label {
            display: flex;
            align-items: center;
            padding: 0 10px;
            .input-checkbox {
              margin: 0px 7px;
              position: relative;
              top: -1px;
              cursor: pointer;
              outline: none !important;
              box-shadow: 0px 0px 0px 1px #fff;
              &:after {
                content: "";
                position: absolute;
                top: -2px;
                right: -2px;
                bottom: -2px;
                left: -2px;
                border: 1.27955px solid #9c9c9c;
                border-radius: 3.83865px;
                @media (min-width: 1200px) and (max-width: 1700px) {
                  top: -2.5px;
                  right: -1.5px;
                  bottom: -1.5px;
                  left: -2.5px;
                }
              }
              &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: #fff !important;
              }
              &:focus {
                outline: none !important;
              }
              &:checked {
                &:before {
                  background: transparent !important;
                }
              }
            }

            h3 {
              font-size: 14px;
              padding-left: 3px;
            }
          }
        }
      }
      .inputs {
        padding: 20px;
        .el-select .el-input .el-select__caret {
          color: #0a5da6;
          color: #34495e;
        }
      }
    }
    &__footer {
      margin-top: 3px;
      background: white;
      border-radius: 6px;
      .collapse-header {
        .header-section {
          height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 5px 15px;
          .data-include-sub-header {
            display: flex;
            align-items: center;
          }
          .download-btn {
            min-height: 30px;
            max-height: 30px;
            padding: 5px 10px;
            font-size: 13px;
            background: #273480;

            color: #fff;
            font-weight: 500;
            border: none;
            border-radius: 6.4px;
            text-transform: uppercase;
            transition: all 0.2s ease-in-out;
          }
          .checkbox-sub-header {
            color: #0a5da6;
            font-weight: 500;
            font-size: 14px;
          }
          @include checkbox-styles;
          .search-checkbox {
            margin-top: 4px;
          }
        }
        .date-includes {
          .check-list {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            padding-right: 30px;
            padding: 10px 0;
            @include checkbox-styles;
            @media (min-width: 1650px) {
              grid-template-columns: repeat(7, 1fr);
            }
            .search-checkbox {
              margin-left: 15px;
            }
          }
        }
      }
      .el-collapse-item__header {
        border-radius: 6px 6px 0 0;
        height: 40px;
      }
      .el-collapse-item__wrap {
        border-radius: 0 0 6px 6px;
      }
    }
  }
  .clear-btn {
    padding: 5px 0;
    width: 95%;
    margin: auto;
    text-align: end;
    .button-with-icon {
      min-height: 30px;
    }
  }
}
</style>
